import { render, staticRenderFns } from "./club-theme.vue?vue&type=template&id=227db133&scoped=true&"
import script from "./club-theme.vue?vue&type=script&lang=js&"
export * from "./club-theme.vue?vue&type=script&lang=js&"
import style0 from "./club-theme.vue?vue&type=style&index=0&id=227db133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227db133",
  null
  
)

export default component.exports